import React, { useState } from 'react';
import axios from '../api/axios';
import { toast } from './Toast';
import './ConvertModal.css';

function ConvertModal({ enquiryId, customerId, enquiry, customer, convertType, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    projectName: '',
    startDate: new Date().toISOString().split('T')[0],
    budget: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (convertType === 'customer') {
        await axios.post(`/enquiries/${enquiryId}/convert-to-customer`);
      } else if (customerId) {
        // Customer → Project
        const projectData = {
          name: formData.projectName,
          startDate: formData.startDate,
          budget: parseFloat(formData.budget),
          branchId: customer?.branchId ? parseInt(customer.branchId) : null
        };
        await axios.post(`/customers/${customerId}/convert-to-project`, projectData);
      } else {
        // Enquiry → Project
        const projectData = {
          name: formData.projectName,
          startDate: formData.startDate,
          budget: parseFloat(formData.budget),
          branchId: enquiry?.branchId ? parseInt(enquiry.branchId) : null
        };
        await axios.post(`/enquiries/${enquiryId}/convert-to-project`, projectData);
      }
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || `Failed to convert to ${convertType}`);
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{customerId ? 'Add Project' : `Convert to ${convertType === 'customer' ? 'Customer' : 'Project'}`}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {convertType === 'customer' ? (
            <div className="convert-info">
              <p>This will create a new customer with the following details:</p>
              <div className="info-preview">
                <div className="preview-item">
                  <strong>Name:</strong> {enquiry.customerName}
                </div>
                <div className="preview-item">
                  <strong>Phone:</strong> {enquiry.phone}
                </div>
                <div className="preview-item">
                  <strong>Email:</strong> {enquiry.email || 'Not provided'}
                </div>
              </div>
              <p className="warning-text">
                The enquiry status will be updated to CONVERTED.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} id="convert-form">
              <div className="convert-info">
                <p>This will create a new project with the following details:</p>
                <div className="info-preview">
                  <div className="preview-item">
                    <strong>Customer Name:</strong>{' '}
                    {customer ? customer.name : enquiry ? enquiry.customerName : ''}
                  </div>
                  <div className="preview-item">
                    <strong>Phone:</strong>{' '}
                    {customer ? customer.phone : enquiry ? enquiry.phone : ''}
                  </div>
                  <div className="preview-item">
                    <strong>Email:</strong>{' '}
                    {(customer ? customer.email : enquiry ? enquiry.email : '') || 'Not provided'}
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="projectName">Project Name *</label>
                <input
                  type="text"
                  id="projectName"
                  name="projectName"
                  value={formData.projectName}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  className="form-input"
                  maxLength="200"
                  placeholder="Enter project name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="startDate">Start Date *</label>
                <input
                  type="date"
                  id="startDate"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="budget">Budget *</label>
                <input
                  type="number"
                  id="budget"
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  className="form-input"
                  min="0"
                  step="0.01"
                  placeholder="Enter project budget"
                />
              </div>

              {!customerId && (
                <p className="warning-text">
                  The enquiry status will be updated to CONVERTED.
                </p>
              )}
            </form>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={convertType === 'project' ? 'submit' : 'button'}
            form={convertType === 'project' ? 'convert-form' : undefined}
            className="btn btn-primary"
            onClick={convertType === 'customer' ? handleSubmit : undefined}
            disabled={loading}
          >
            {loading 
              ? (customerId ? 'Adding...' : 'Converting...') 
              : (customerId ? 'Add Project' : `Convert to ${convertType === 'customer' ? 'Customer' : 'Project'}`)}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConvertModal;
